import type { ConsultStage, ConsultType } from '../exchange/exchange-types.js';

export type OneToOneSubsections = {
  showInitialBlock: boolean;
  showFollowUpBlock: boolean;
  showFollowUpHeading: boolean;
  /** Non-FFS: one Zoom team URL, neutral section title (not "Follow-up Consult"). */
  showGenericOneToOneScheduleHeading: boolean;
};

/**
 * For `ffs`, `consultStage` limits which blocks appear inside the 1:1 tab; other types ignore
 * `consultStage`. `1:1` / `flexible` use a single program URL (`followUpConsultScheduleUrl` only).
 */
export function oneToOneSubsections(params: {
  consultType: ConsultType | undefined;
  consultStage: ConsultStage | undefined;
  hasInitialScheduleUrl: boolean;
  hasProgramFollowUpUrl: boolean;
}): OneToOneSubsections {
  const { consultType, consultStage, hasInitialScheduleUrl, hasProgramFollowUpUrl } = params;
  const isFfs = consultType === 'ffs';
  const hideInitialForStage = isFfs && consultStage === 'follow-up';
  const hideFollowUpForStage = isFfs && consultStage === 'initial';

  const showInitialBlock = !hideInitialForStage && hasInitialScheduleUrl;
  const showFollowUpBlock = !hideFollowUpForStage;
  const showFollowUpHeading =
    showFollowUpBlock && (showInitialBlock || (isFfs && consultStage === 'follow-up'));
  const showGenericOneToOneScheduleHeading =
    !isFfs && showFollowUpBlock && hasProgramFollowUpUrl && !hasInitialScheduleUrl;

  return {
    showInitialBlock,
    showFollowUpBlock,
    showFollowUpHeading,
    showGenericOneToOneScheduleHeading,
  };
}
